import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class ToasterService {

    constructor(private snackBar: MatSnackBar) {
    }

    showToaster(msg: string, durationCount: number) {
        this.snackBar.open(msg, null, {
            duration: durationCount,
        });
    }
}
